/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Switch, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",

  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "wrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",

  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function TableGDLK01a({ formData, setFieldValue }) {
  const [data, setData] = useState([
    {
      id: uuidV4(),
      name: "",
      country: "",
      taxId: "",
      relationshipA: false,
      relationshipB: false,
      relationshipC: false,
      relationshipD: false,
      relationshipDD: false,
      relationshipE: false,
      relationshipG: false,
      relationshipH: false,
      relationshipI: false,
      relationshipK: false,
      relationshipL: false,
    },
  ]);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        name: "",
        country: "",
        taxId: "",
        relationshipA: false,
        relationshipB: false,
        relationshipC: false,
        relationshipD: false,
        relationshipDD: false,
        relationshipE: false,
        relationshipG: false,
        relationshipH: false,
        relationshipI: false,
        relationshipK: false,
        relationshipL: false,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-start">
        <Typography variant="h6">MỤC I. THÔNG TIN VỀ CÁC BÊN LIÊN KẾT</Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", minWidth: 400 }}>
                Tên bên liên kết
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", minWidth: 200 }}>
                Quốc gia
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", minWidth: 300 }}>
                Mã số thuế
              </Td>
              <Td rowSpan={1} colSpan={11} style={{ textAlign: "center" }}>
                Hình thức quan hệ liên kết
              </Td>
            </tr>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} colSpan={11} style={{ textAlign: "center" }}>
                (5)
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>A</Td>
              <Td style={{ textAlign: "center" }}>B</Td>
              <Td style={{ textAlign: "center" }}>C</Td>
              <Td style={{ textAlign: "center" }}>D</Td>
              <Td style={{ textAlign: "center" }}>Đ</Td>
              <Td style={{ textAlign: "center" }}>E</Td>
              <Td style={{ textAlign: "center" }}>G</Td>
              <Td style={{ textAlign: "center" }}>H</Td>
              <Td style={{ textAlign: "center" }}>I</Td>
              <Td style={{ textAlign: "center" }}>K</Td>
              <Td style={{ textAlign: "center" }}>L</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {+index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable id={item.id} name="name" value={item.name} onChange={handleChange} />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "country", e.target.value)}
                  >
                    <option value="Quốc gia A">Quốc gia A</option>
                    <option value="Quốc gia B">Quốc gia B</option>
                    <option value="Quốc gia C">Quốc gia C</option>
                  </select>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="taxId"
                    value={item.taxId}
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipA}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipA" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipB}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipB" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipC}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipC" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipD}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipD" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipDD}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipDD" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipE}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipE" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipG}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipG" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipH}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipH" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipI}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipI" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipK}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipK" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  <Switch
                    checked={item.relationshipL}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "relationshipL" })
                    }
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        minWidth: 180,
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
